import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogProps,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
} from '@material-ui/core';
import { FiX } from 'react-icons/fi';

import clsx from 'clsx';
import { useStyles } from './styles';

interface FilterByYearProps extends DialogProps {
  min: number;
  max: number;
  selectedYear: number;
  onChangeYear: (year: number) => void;
  onClose?: () => void;
}

const FilterByYear: React.FC<FilterByYearProps> = ({
  min,
  max,
  selectedYear,
  onChangeYear,
  onClose,
  ...rest
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleClose = (): void => {
    if (onClose) {
      onClose();
    }
  };

  const years = useMemo(() => {
    const allYears: number[] = [];
    for (let i = 0; i <= max - min; i += 1) {
      allYears.push(min + i);
    }
    return allYears;
  }, [min, max]);

  return (
    <Dialog
      className={classes.container}
      aria-labelledby={t('screens:results.filterByYear')}
      aria-describedby={t('screens:results.filterByYear')}
      {...rest}
    >
      <IconButton
        size="small"
        className={classes.closeButton}
        onClick={() => handleClose()}
      >
        <FiX color="hsla(0, 0%, 20%, 1)" size={16} />
      </IconButton>
      <DialogContent className={classes.content}>
        <Typography variant="subtitle1" className={classes.title}>
          {t('screens:results.filterByYear')}
        </Typography>
        <List component="nav" aria-label="filter by year">
          {years.map((yr, index) => {
            return index < years.length - 1 ? (
              <div key={yr}>
                <ListItem
                  button
                  alignItems="center"
                  onClick={() => onChangeYear(yr)}
                >
                  <ListItemText
                    primary={yr}
                    className={clsx(classes.listText, {
                      [classes.selected]: selectedYear === yr,
                    })}
                  />
                </ListItem>
                <Divider variant="fullWidth" />
              </div>
            ) : (
              <ListItem
                key={yr}
                button
                alignItems="center"
                onClick={() => onChangeYear(yr)}
              >
                <ListItemText
                  primary={yr}
                  className={clsx(classes.listText, {
                    [classes.selected]: selectedYear === yr,
                  })}
                />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default FilterByYear;
